import { isIOS, isMobile } from 'shared'
import { createRoot, onMount } from 'solid-js'
import { createStore } from 'solid-js/store'

type State = {
    is_ios: boolean
    is_mobile: boolean

    inner_width: number
}
const [app_state, setState] = createStore<State>({
    is_ios: false,
    is_mobile: false,

    inner_width: 1920,
})
export { app_state }

createRoot(() => {
    onMount(() => {
        setState({
            is_ios: isIOS(),
            is_mobile: isMobile(),
            inner_width: window.innerWidth,
        })
    })
})
